import { useGetOrderQuery } from '../../apis/mlkApi/mlk.api.hooks';
import { getCorrectStatus } from '../../helpers/order';
import { useIsNoAssign } from '../useIsNoAssign';
import { useOrderId } from '../useOrderId';

export const useCalculatedOrderStatus = () => {
  const orderId = useOrderId(true);
  const isNoAssign = useIsNoAssign();
  const { data: order } = useGetOrderQuery(
    { orderId: orderId || '', isNoAssign },
    {
      skip: !orderId,
    }
  );
  const calculatedStatus = order && getCorrectStatus(order);
  return calculatedStatus;
};
